import { useGetMerchantQuery } from "Api/Queries/Merchants/useGetMerchantQuery";
import { ControlledCardsListSkeleton } from "Components/Shared/CardsList/ControlledCardsListSkeleton";
import { ErrorText } from "Components/Shared/Errors/ErrorText";
import { FormSection } from "Components/Shared/FormSection";
import { Facilities } from "Components/Shared/Merchant/Facilities/Facilities";
import type { ReactNode } from "react";
import { getRegionCurrency } from "Utils/CurrencyUtils";
import { Resources, useResource } from "Translations/Resources";

const COMPONENT_RESOURCES = Resources.Components.Merchant.Facilities;

export const CurrentMerchantFacilities = () => {
  const { data, isLoading, isError } = useGetMerchantQuery();
  const { t } = useResource();

  if (isLoading) {
    return (
      <Layout>
        <ControlledCardsListSkeleton />
      </Layout>
    );
  }

  if (!data || isError) {
    return (
      <Layout>
        <ErrorText>{t(COMPONENT_RESOURCES.LoadingError)}</ErrorText>
      </Layout>
    );
  }

  const { facilities, publicID, party } = data;

  return (
    <Facilities
      facilities={facilities}
      merchantPublicID={publicID}
      partyPublicID={party?.publicID}
      marketCurrencyCode={
        party?.region ? getRegionCurrency(party.region) : undefined
      }
    />
  );
};

const Layout = ({ children }: { children: ReactNode }) => {
  const { t } = useResource();

  return (
    <FormSection legend={t(COMPONENT_RESOURCES.Title)}>{children}</FormSection>
  );
};
